import React, { Component } from "react";
import InputForm from "../../html/inputForm";
import { bulbIcon } from "../../../utils/images";
import commonContext from "../../../context/common";
import SelectForm from "../../html/selectForm";

interface IProps {
    onclickhandler: Function;
}
class PersonalAlternateAddress extends Component<IProps, {}> {
    static contextType = commonContext;
    handleOnChange = (e: any) => {
        const { setLead } = this.context;
        let state = {};
        state[e.target.name] = e.target.value;
        setLead(state);
    };
    handleOnSubmit = () => {
        this.props.onclickhandler();
    };
    handleOnStateChange = async (e: any) => {
        const { setLead, apis, lead } = this.context;
        setLead({
            citysList: [],
        });
        const apiData = await apis.getCities({ state: lead.pdPermState });
        setLead({
            citysList: apiData.result,
        });
    };
    render() {
        const { lead } = this.context;
        return (
            <>
                <div className="container my-5 mx-auto px-2 md:px-5">
                    <h2 className="openSans-Reg text-black my-3 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Alternate Address
                    </h2>
                    <div>
                        <form>
                            <div className="flex flex-wrap w-full">
                                <div className="w-full mb-3 relative ">
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <InputForm
                                            label="Pincode"
                                            errorText="Please eneter Pincode"
                                            name="pdPermPinCode"
                                            handlerOnChange={(e) =>
                                                this.handleOnChange(e)
                                            }
                                            value={lead.pdPermPinCode}
                                        />
                                    </div>
                                </div>
                                <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <SelectForm
                                        title="State"
                                        options={lead.statesArray}
                                        errorText="please enter state"
                                        noneText="Select State"
                                        name="pdPermState"
                                        objectKey="state"
                                        handlerOnChange={async (e) => {
                                            await this.handleOnChange(e);
                                            await this.handleOnStateChange(e);
                                        }}
                                        value={lead.pdPermState}
                                    />
                                </div>
                                <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                    <SelectForm
                                        title="City"
                                        options={lead.citysList}
                                        errorText="please enter City"
                                        noneText="Select City"
                                        name="pdPermCity"
                                        objectKey="city"
                                        handlerOnChange={(e) =>
                                            this.handleOnChange(e)
                                        }
                                        value={lead.pdPermCity}
                                    />
                                </div>
                                <div className="relative flex flex-wrap w-full">
                                    <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 w-full">
                                        Work Address
                                    </label>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <InputForm
                                            name="pdPermAddress"
                                            handlerOnChange={(e) =>
                                                this.handleOnChange(e)
                                            }
                                            value={lead.pdPermAddress}
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <InputForm
                                            name="pdPermAddress2"
                                            handlerOnChange={(e) =>
                                                this.handleOnChange(e)
                                            }
                                            value={lead.pdPermAddress2}
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <InputForm
                                            name="pdPermAddress3"
                                            handlerOnChange={(e) =>
                                                this.handleOnChange(e)
                                            }
                                            value={lead.pdPermAddress3}
                                        />
                                    </div>
                                    <span className="hidden error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm">
                                        Please enter Work Address
                                    </span>
                                </div>
                                <div className="bg-light-yellow w-full lg:w-8/12 text-grey-darkest openSans-Reg py-2 px-4 my-4 text-sm rounded inline-flex items-start md:items-center">
                                    <img
                                        src={bulbIcon}
                                        alt="Information icon"
                                        title="Information icon"
                                        className="mr-3"
                                    />
                                    <span>
                                        Please note that a representative from
                                        HDFC will be visiting you to collect
                                        documents and ID proof for you to be
                                        able to successfully register your new
                                        address.
                                    </span>
                                </div>
                                <div className="w-full  my-6 text-center">
                                    <button
                                        type="submit"
                                        className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                                        title="Save"
                                        onClick={() => this.handleOnSubmit()}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </>
        );
    }
}

export default PersonalAlternateAddress;
